/**
 * Created by lari on 09/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcreminder')
    .component('allreminders', {
      restrict: 'E',
      bindings: {},
      templateUrl: 'vcreminder/allreminders-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Reminder', 'Client', 'Clientlog', 'vertxEventBusService',
        function ($log, Reminder, Client, Clientlog, vertxEventBusService) {
          let vm = this;
          vm.save = save;
          vm.switchRange = switchRange;

          vm.$onInit = function () {
            vm.weeks = 2;
            // vm.upcoming = moment().add(2, 'weeks').toISOString();
            vm.name = 'allReminder';

            vm.todos = {};
            vm.todos.upcoming = upcoming();
            vm.todos.overdue = dueandoverdue();
            vm.todos.lastcompleted = lastcompleted();
          };


          function lastcompleted() {
            return Reminder.$search({
              completed: {
                $lt: moment().toISOString(),
                $gte: moment().subtract(2, 'days').toISOString()
              }, done: true
            });
          }

          function upcoming() {
            return Reminder.$search({
              due: {
                $lt: moment().add(vm.weeks, 'weeks').toISOString(),
                $gte: moment().add(1, 'days').startOf('day').toISOString()
              }, done: false
            });
          }

          function dueandoverdue() {
            return Reminder.$search({
              due: {$lt: moment().add(1, 'days').startOf('day').toISOString()},
              done: false
            });
          }

          function switchRange(weeks) {
            vm.weeks = weeks;
            vm.todos.upcoming = upcoming();
          }

          function save(item) {
            let logentry = {};
            logentry.created = moment().toISOString();
            logentry.clientid = item.clientid;
            if (angular.isDefined(item.patientid)) {
              logentry.patientid = item.patientid;
            } else {
              logentry.patientid = item.clientid;
            }

            if (item.done === true) {
              item.completed = moment().toISOString();
              logentry.entry = 'Todo abgeschlossen: ' + item.label;
            }
            if (item.done === false) {
              delete item.completed;
              logentry.entry = 'Todo wieder geöffnet: ' + item.label;
            }
            item.$save().$asPromise().then(function () {
              refreshAll();
              Clientlog.$create(logentry);
            });
          }

          function refreshAll() {
            vm.todos.upcoming.$refresh();
            vm.todos.overdue.$refresh();
            vm.todos.lastcompleted.$refresh();
          }

          vertxEventBusService.on('reminders.update', function (message) {
            $log.debug('debug: reminder update received: ', message);
            let messages = message.split(':');
            refreshAll();

          });

        }] // controller
    }); // component

// klammerfriedhof
}());